var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 567 567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil-black {fill:#333}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil-black",
    points: "173.081,368.78 272.464,269.397 173.081,170.015 189.704,153.392 289.087,252.776 388.469,153.392 405.092,170.015 305.71,269.398 405.092,368.78 388.469,385.403 289.086,286.02 189.704,385.403 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.7922370c8c2e9162af96e8ae4acd6bb3.svg";
export { ForwardRef as ReactComponent };